import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const SELECTOR = [
  ".nfw-section",
  ".nfw-hero",
  ".nfw-product-hero",
  ".nfw-post-hero",
  ".nfw-footer",
].join(", ");

export default function ScrollReveal() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const nodes = Array.from(document.querySelectorAll(SELECTOR));
    const inView = (el) => {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.92 && rect.bottom > 48;
    };

    nodes.filter(inView).forEach((el) => el.classList.add("is-in"));
    document.documentElement.classList.add("nfw-anim");

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    nodes.filter((el) => !el.classList.contains("is-in")).forEach((el) => {
      io.observe(el);
    });

    return () => io.disconnect();
  }, [pathname]);

  return null;
}
